import { render } from "./Validation.vue?vue&type=template&id=24916874&scoped=true&ts=true"
import script from "./Validation.vue?vue&type=script&lang=ts"
export * from "./Validation.vue?vue&type=script&lang=ts"

import "./Validation.vue?vue&type=style&index=0&id=24916874&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24916874"]])

export default __exports__